module.exports = __webpack_public_path__ + "media/sub2-8-2.7e4f7d80.mp4";